(() => {
  document.addEventListener('shopify:block:select', (event) => {
    const block = event.target;
    if (!(block instanceof Element)) return;
    const section = block.closest('[data-gym-section]');
    if (!section) return;
    if (block instanceof HTMLDetailsElement) block.open = true;
    const gallery = block.closest('[data-gym-gallery]');
    if (gallery) {
      gallery.scrollTo({ left: block.offsetLeft - gallery.offsetLeft, behavior: 'instant' });
    }
  });
})();
